export interface PromotionPageConfig {
    title: string;
    subtitle: string;
    learnMoreUrl?: string;
    videoUrl?: string;
    videoTitle?: string;
    ctaUrl?: string;
}

/**
 * Per-route promotion configs keyed by route path segment.
 * Titles / subtitles are placeholders — fill in real copy later.
 */
export const PROMOTION_CONFIGS: Record<string, PromotionPageConfig> = {
    reporting: {
        title: 'Unlock Reporting',
        subtitle: 'Get real-time financial reports powered by your live data.',
        videoUrl: 'https://datarails-2.wistia.com/medias/ba3h3rtfvv',
    },
    planning: {
        title: 'Unlock Planning',
        subtitle: 'Build dynamic budgets and forecasts with AI-powered planning.',
        videoUrl: 'https://datarails-2.wistia.com/medias/fzqj0wj8py',
    },
    cash: {
        title: 'Unlock Cash',
        subtitle: 'Monitor and forecast your cash flow in real time.',
        videoUrl: 'https://datarails-2.wistia.com/medias/9z7dy1zjmb',
    },
    'month-end-close': {
        title: 'Unlock Month-End Close',
        subtitle: 'Automate reconciliations and close the books faster.',
        videoUrl: 'https://datarails-2.wistia.com/medias/j6rtai7hmf',
    },
    'spend-control': {
        title: 'Unlock Spend Control',
        subtitle: 'Track and manage company spend with full visibility.',
        videoUrl: 'https://datarails-2.wistia.com/medias/e5lpzhq3vf',
    },
    'claude-connector': {
        title: 'Connect FinanceOS with Claude',
        subtitle:
            'Run deep analysis on your financial data, explore trends, and get clear explanations for complex questions directly in Claude.',
        videoTitle: 'FinanceOS x Claude',
        videoUrl: 'https://datarails-2.wistia.com/medias/6sg1jxnxwv',
        ctaUrl: 'https://www.datarails.com/request-a-demo/',
    },
    'chatgpt-connector': {
        title: 'Connect FinanceOS with ChatGPT',
        subtitle: 'Ask questions and analyze your data directly inside ChatGPT using FinanceOS.',
        videoTitle: 'FinanceOS x ChatGPT',
        videoUrl: 'https://datarails-2.wistia.com/medias/w95j3s722j',
        ctaUrl: 'https://www.datarails.com/request-a-demo/',
    },
    'lovable-connector': {
        title: 'Connect FinanceOS with Lovable',
        subtitle: 'Create custom tools, automate workflows, and build internal apps using your financial data.',
        videoTitle: 'FinanceOS x Lovable',
        videoUrl: 'https://datarails-2.wistia.com/medias/6icld2bh5v',
        ctaUrl: 'https://www.datarails.com/request-a-demo/',
    },
};
